import * as Yup from "yup";
import { reverseShape } from "Helpers/reverse-shape";
import {
  email,
  fullName,
  postcode,
  fullContact,
  prefix,
} from "Utils/validations";

const CustomerIndividualFormSchema = Yup.object().shape(
  reverseShape({
    customerName: fullName.required(),
    emailAddress: email.required(),
    street1: Yup.string().max(100).required(),
    street2: Yup.string().max(100).optional(),
    postcode: Yup.string().when("country", {
      is: "MY",
      then: postcode.required(),
    }),
    city: Yup.string().max(50).required(),
    state: Yup.string().max(50).required(),
    cityCode: Yup.string().max(50).optional(),
    stateCode: Yup.string().max(50).optional(),
    country: Yup.string()
      .matches(/^[a-zA-Z]{2}$/i)
      .required(),
    mobileNo: fullContact.required(),
    parentOrgID: Yup.string().required(),
    // password: password.when(
    //   "_id", {
    //     is: (value) => !value,
    //     then: password.optional(),
    //     otherwise: password.optional()
    //   }
    // ),
    // confirmPwd: Yup.string().oneOf([Yup.ref('password'), null]),
    prefix: prefix.required(),
    acceptTerms: Yup.bool().when("_id", {
      is: (value) => !value,
      then: Yup.bool().oneOf([true]),
      otherwise: Yup.bool().optional(),
    }),
    parcelTypes: Yup.array().min(1).required(),
    allowPickupAll: Yup.bool().required()
  }),
);

export default CustomerIndividualFormSchema;
